import { postSplitOrder, postSplitOrderNew } from "../../request/designapi/design/softwareOneKey/splitOrder/post.js";
async function postSplitOrderData(params) {
  const res = await postSplitOrder(params);
  if (res.status) {
    return res.data;
  } else {
    throw new Error(res.message);
  }
}
async function postSplitOrderDataNew(params) {
  const res = await postSplitOrderNew(params);
  if (res.status) {
    return res.data;
  } else {
    throw new Error(res.message);
  }
}
export { postSplitOrderData, postSplitOrderDataNew };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/kujiale/getCurrentCupboardInfo.js